import styles from './AboutUs.module.css';

const MissionCard = () => {
    return ( 
        <div className={` ${styles.missioncard} ${styles.card}`}></div>
     );
}
 
export default MissionCard;